declare const MOCK_API_DATE: string;
declare const MOCK_API_DATA_DIR: string;

export const mockApiDate = window['mockApiDate'] || MOCK_API_DATE;
export const mockApiDataDir = window['mockApiDataDir'] || MOCK_API_DATA_DIR;
